<app-header></app-header>
<app-deal-list></app-deal-list>
